import React from 'react'
import './Contactdata.css'
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa6";
import { useRef } from 'react';
import emailjs from 'emailjs-com';


const ContactData = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_8ks1mmq', 'template_6uun103', form.current, '6vVqujtUV_1bYU7YT')

        e.target.reset()
    };

    return (
        <section id='contact'>
            <h5 data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="650"
                data-aos-offset="170" >Get In Touch</h5>
            <h2 data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="850"
                data-aos-offset="170">Contact</h2>

            <div className="container-2">
                <div className="contact__container">
                    <div className="contact__options">
                        <div data-aos="fade-right"
                            data-aos-easing="linear"
                            data-aos-duration="500"
                            data-aos-offset="170" >
                            <article className='contact__option'>
                                <a href="mailto:m.metwally.rzq@gmail.com" target="_blank" rel='noreferrer'>
                                    <MdOutlineMarkEmailUnread className='contact__options-icon' />
                                    <h4>Email</h4>
                                    <p>m.metwally.rzq@gmail.com</p>
                                    <br />
                                    <p>Click Me</p>
                                </a>
                            </article>
                        </div>


                        <div data-aos="fade-right"
                            data-aos-easing="linear"
                            data-aos-duration="500"
                            data-aos-offset="150" >
                            <article className='contact__option'>
                                <a href="https://api.whatsapp.com/send?phone=201021340475" target="_blank" rel='noreferrer' className='text-light'>
                                    <FaWhatsapp className='contact__options-icon' />
                                    <h4>Whatsapp</h4>
                                    <p>+201021340475</p>
                                    <br />
                                    <p>Click Me</p>
                                </a>
                            </article>
                        </div>
                    </div>

                    <div>
                        <form ref={form} onSubmit={sendEmail}>
                            <input data-aos="fade-down-left"
                                data-aos-easing="linear"
                                data-aos-duration="500"
                                data-aos-offset="150" type="mail" name='Name' placeholder='Your Full Name' required />
                            <input data-aos="fade-down-left"
                                data-aos-easing="linear"
                                data-aos-duration="650"
                                data-aos-offset="150" type="email" name='email' placeholder='Your Email' required />
                            <textarea data-aos="fade-down-left"
                                data-aos-easing="linear"
                                data-aos-duration="800"
                                data-aos-offset="150" name="message" rows="7" placeholder='Your Message' required ></textarea>
                            <button data-aos="fade-left"
                                data-aos-easing="linear"
                                data-aos-duration="950"
                                data-aos-offset="150" type='submit' className='btn btn-primary'>Send Message</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default ContactData